"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectVariation = exports.isParticipating = exports.getExperimentVariation = exports.default = exports.assignVariation = void 0;
var _ExperimentConnector = _interopRequireDefault(require("./connectors/ExperimentConnector"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* global cxApi*/

var getExperimentVariation = function getExperimentVariation() {
  return _ExperimentConnector.default.getChosenVariation();
};
exports.getExperimentVariation = getExperimentVariation;
var isParticipating = function isParticipating() {
  return _ExperimentConnector.default.isParticipating();
};
exports.isParticipating = isParticipating;
var assignVariation = function assignVariation() {
  return _ExperimentConnector.default.assignVariation();
};
exports.assignVariation = assignVariation;
var selectVariation = function selectVariation(variation, experiment) {
  return _ExperimentConnector.default.selectVariation(variation, experiment);
};
exports.selectVariation = selectVariation;
var _default = {
  getExperimentVariation: getExperimentVariation,
  isParticipating: isParticipating,
  assignVariation: assignVariation,
  selectVariation: selectVariation
};
exports.default = _default;
//# sourceMappingURL=Experiment.js.map